import { takeEvery, all, call, put } from 'redux-saga/effects';

import * as types from './orderStatusActionTypes';
import * as actions from './orderStatusActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getOrderStatusSaga(action) {
  try {
    console.log('getOrderStatusSaga action:', action);
    
    const userData = JSON.parse(localStorage.getItem('user'));
    const sessionUserId = localStorage.getItem('sessionUserId');
    
    const userId = sessionUserId || userData?.sessionUserId || userData?.user?.sessionUserId;
    
    const payload = {
      SessionUserId: String(userId),
    };

    console.log('API payload:', payload);
    console.log('User data from localStorage:', userData);
    console.log('SessionUserId from localStorage:', sessionUserId);
    console.log('Final userId:', userId);
    
    if (!userId || userId === 'undefined') {
      console.error('SessionUserId not found in localStorage');
      yield put(actions.getOrderStatusErrorAction({
        message: 'User session not found. Please login again.'
      }));
      return;
    }
    
    const { data } = yield call(endpoints.getOrderStatus, payload);
    console.log('API response:', data);
    
    yield put(actions.getOrderStatusDataAction(data));
  } catch (e) {
    console.error('getOrderStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.getOrderStatusErrorAction(e));
    yield call(errorHandler, e, action.history, action.href);
  }
}

function* createOrderStatusSaga(action) {
  try {
    console.log('createOrderStatusSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create order API payload:', payload);
    
    const { data } = yield call(endpoints.createOrderStatus, payload);
    console.log('Create order API response:', data);
    
    yield put(actions.createOrderStatusDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/order-status');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createOrderStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createOrderStatusErrorAction(e));
    yield call(errorHandler, e, action.history, action.href);
  }
}

function* updateOrderStatusSaga(action) {
  try {
    console.log('updateOrderStatusSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update order API payload:', payload);
    
    const { data } = yield call(endpoints.updateOrderStatus, payload);
    console.log('Update order API response:', data);
    
    yield put(actions.updateOrderStatusDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getOrderStatusRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/order-status');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateOrderStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateOrderStatusErrorAction(e));
    yield call(errorHandler, e, action.history, action.href);
  }
}

function* deleteOrderStatusSaga(action) {
  try {
    console.log('deleteOrderStatusSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete order API payload:', payload);
    
    const { data } = yield call(endpoints.deleteOrderStatus, payload);
    console.log('Delete order API response:', data);
    
    yield put(actions.deleteOrderStatusDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getOrderStatusRequestAction());
    }
    
  } catch (e) {
    console.error('deleteOrderStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.deleteOrderStatusErrorAction(e));
    yield call(errorHandler, e, action.history, action.href);
  }
}

// Watcher Sagas
function* watchGetOrderStatus() {
  yield takeEvery(types.GET_ORDER_STATUS_REQUEST, getOrderStatusSaga);
}

function* watchCreateOrderStatus() {
  yield takeEvery(types.CREATE_ORDER_STATUS_REQUEST, createOrderStatusSaga);
}

function* watchUpdateOrderStatus() {
  yield takeEvery(types.UPDATE_ORDER_STATUS_REQUEST, updateOrderStatusSaga);
}

function* watchDeleteOrderStatus() {
  yield takeEvery(types.DELETE_ORDER_STATUS_REQUEST, deleteOrderStatusSaga);
}

export function* orderStatusSaga() {
  yield all([
    watchGetOrderStatus(),
    watchCreateOrderStatus(),
    watchUpdateOrderStatus(),
    watchDeleteOrderStatus(),
  ]);
}